import styled from 'styled-components'

export const FormTitle = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.text}; 
    font-size: 22px; 
    font-family: Gilroy;
    font-weight: 700;
`;

export const HeroTitle = styled.div.attrs({})`
    width: 100%;
    max-width: 520px;
    margin: 0 auto 4px;
    text-align: center;
    font-family: Gilroy;
    font-size: clamp(36px, 4vw, 48px);
    font-weight: 700;
    line-height: 1.02;
    letter-spacing: -0.04em;
    color: ${props => props.theme.palette.colors.text};
`;

export const FormText = styled.div.attrs({
})`
    font-size: 18px; 
    color: ${props => props.theme.palette.colors.muted};
    text-align: ${p => p.center ? `center;` : ''};
    max-width: 760px;
    line-height: 1.65;
    padding: 4px 8px;

    ${p => p.info ? `
        font-size: 15px;
        color: ${p.theme.palette.colors.subdued};
        padding: 0;
    ` : ''};
`;
export const InfoTitle = styled.div.attrs({
})`
    font-size: 18px; 
    color: ${props => props.theme.palette.colors.text};
    font-weight: 600;
    min-width: 160px;
`;

export const InfoSpace = styled.div.attrs({
})`        
    width: 100%;
    max-width: 760px;
    margin: 8px auto 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
`;
export const FormSpacer = styled.div.attrs({
})`           
    margin-top: 40px;
`;
export const FormBorder = styled.div.attrs({
})`           
    width: 1px;
    min-height: 60px;
    background: ${p => p.theme.palette.colors.borderSoft};
    @media (max-width: 700px) {
        display: none;
    }
`;

export const RegisterForgot = styled.div.attrs({
})`           
    display: flex;
    justify-content: center;
`;

export const ForgotLink = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.blue.main};
    font-size: 16px;
    font-family: Gilroy;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
`;

export const RegisterCall = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.muted};
    font-size: 15;
    font-weight: bold;
`;
export const LoginContainer = styled.div.attrs({
})`           
    background: transparent;
    width: 100%;
    height: 100%;
    max-width: 520px;
    margin: 0 auto;
`;
export const LoginContent = styled.div.attrs({
})`           
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 28px;
`;

export const LoginInfoContent = styled.div.attrs({
})`           
    display: flex;
    gap: 16px;
    align-items: flex-start;
    border: 1px solid ${p => p.theme.palette.colors.borderSoft};
    background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
    border-radius: 20px;
    min-height: 84px;
    padding: 18px 20px;
    box-shadow: 0 18px 42px ${p => p.theme.palette.colors.shadowStrong};
    @media (max-width: 700px) {
        flex-direction: column;
        padding: 16px 18px;
    }
`;

export const Title = styled.div.attrs({
})`           
    font-weight: Gilroy;
    font-size: ${props => props.small ? `20px` : `32px`};
    font-weight: 700;
    text-align: ${props => props.centred ? `center` : `left`};
    margin-bottom: ${props => props.nomargin ? `0` : `16px`};
    text-transform: ${props => props.upper ? `uppercase` : `none`};
    color: ${props => props?.primary ? props.theme.palette.colors.text : props.theme.palette.colors.text};
`;
